<template>
  <div class="dropdown select" ref="dropdownMenu">
    <div class="flexBetween" @click.prevent="visible = !visible">
      <p class="value textBlack">{{ title }}</p>
      <p class="fas fa-chevron-down end-xs"></p>
    </div>
    <transition name="slide-fade">
      <div v-if="visible" class="dropdownPopDown closeOnMe full-width max-height padding">
        <div v-if="showfilter" class="formGroup transparent withIcon margin-b10">
          <input v-model="searchTerm" placeholder="Search...">
          <span v-if="searchTerm" @click="searchTerm = null" class="icon-cross textRed fontHeavy" style="z-index:2;"></span>
        </div>
        <div v-if="multiple">
          <div class="quickFlex margin-b5 textUppercase" style="justify-content: space-between;">
            <a @click="selectAll()">select all</a>
            <a @click="clearAll()">clear</a>
          </div>
          <div v-for="(item, index) in filteredData()" :key="index" class="formGroup checkbox highlight">
            <label :for="item.label">
              <input type="checkbox" :name="item.value" :id="item.label" :checked="item.selected" @change="update">
              <span class="width90 widthMob80">{{item.label}}</span>
            </label>
          </div>
        </div>
        <div v-if="!multiple">
          <div v-if="placeholder && !searchTerm" class="formGroup highlight">
            <span @click="() => select('')" class="width90 widthMob80">{{placeholder}}</span>
          </div>
          <div v-for="(item, index) in filteredData()" :key="index" @click="() => select(item.value || item)" class="formGroup highlight">
            <span class="width90 widthMob80">{{item.label || item}}</span>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["data", "title", "update", "multiple", "placeholder", "showfilter"],
  data() {
    return {
      visible: false,
      searchTerm: ""
    };
  },
  methods: {
    documentClick(e) {
      let el = this.$refs.dropdownMenu;
      let target = e.target;
      if (el !== target && !el.contains(target)) {
        this.visible = false;
      }
    },
    filteredData() {
      if (this.searchTerm) return this.data.filter(d => d.label.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1);
      else return this.data;
    },
    select(value) {
      this.update(value);
      this.visible = false;
    },
    clearAll() {
      for (let i = 0; i < this.data.length; i++) {
        const element = this.data[i];
        this.update({
          target: {
            name: element.value,
            checked: false
          }
        });
      }
    },
    selectAll() {
      for (let i = 0; i < this.data.length; i++) {
        const element = this.data[i];
        this.update({
          target: {
            name: element.value,
            checked: true
          }
        });
      }
    }
  },
  created() {
    document.addEventListener("click", this.documentClick, false);
  },
  destroyed() {
    document.removeEventListener("click", this.documentClick);
  }
};
</script>
